const GOOGLE_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

export const generateSessionToken = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

export const autocomplete = async (query, sessionToken) => {
  try {
    console.log('🌐 Google Autocomplete 호출:', query);
    
    const response = await fetch('https://places.googleapis.com/v1/places:autocomplete', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Goog-Api-Key': GOOGLE_API_KEY,
      },
      body: JSON.stringify({
        input: query,
        sessionToken: sessionToken,
        locationBias: {
          circle: {
            center: { latitude: 37.5665, longitude: 126.9780 },
            radius: 50000,
          },
        },
        includedPrimaryTypes: ['restaurant', 'cafe', 'bar', 'bakery'],
        languageCode: 'ko',
      }),
    });

    if (!response.ok) {
      const errorText = await response.text();
      console.error('Google API 에러:', errorText);
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    console.log('✅ Google Autocomplete 결과:', data);
    return data.suggestions || [];
  } catch (error) {
    console.error('❌ Autocomplete 오류:', error);
    throw error;
  }
};

export const getPlaceDetails = async (placeId, sessionToken) => {
  try {
    console.log('🌐 Google Place Details 호출:', placeId);
    
    const url = `https://places.googleapis.com/v1/places/${placeId}?sessionToken=${sessionToken}`;
    
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'X-Goog-Api-Key': GOOGLE_API_KEY,
        'X-Goog-FieldMask': 'id,displayName,formattedAddress,location,rating,priceLevel,types',
      },
    });

    if (!response.ok) {
      const errorText = await response.text();
      console.error('Google API 에러:', errorText);
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    console.log('✅ Google Place Details 결과:', data);
    
    return {
      id: data.id,
      name: data.displayName?.text || data.displayName,
      address: data.formattedAddress,
      location: {
        latitude: data.location?.latitude,
        longitude: data.location?.longitude,
      },
      rating: data.rating,
      priceLevel: data.priceLevel,
    };
  } catch (error) {
    console.error('❌ Place Details 오류:', error);
    throw error;
  }
};
